/**
 * Public constants for @inzara/embed-react.
 * Kept in a tiny module so hosts can `import { RESOURCES }` without
 * pulling in React.
 */
export const RESOURCES = Object.freeze({
  INSIGHTS: 'insights',
  KPI_MONITOR: 'kpi-monitor',
  REPORT: 'report',
  DASHBOARD: 'dashboard',
  EXPLORE: 'explore',
  ACTIVITY: 'activity',
  INVESTIGATE: 'investigate',
  MARKETPLACE: 'marketplace',
  ER_DIAGRAM: 'er-diagram',
});

// Which resources render as a standalone page vs the generic
// content-viewer path (/embed/v2/view/:resource/:id).
export const STANDALONE_TARGETS = Object.freeze({
  [RESOURCES.INSIGHTS]:    'insights',
  [RESOURCES.KPI_MONITOR]: 'kpi-monitor',
  [RESOURCES.EXPLORE]:     'explore',
  [RESOURCES.ACTIVITY]:    'activity',
  [RESOURCES.INVESTIGATE]: 'investigate',
  [RESOURCES.MARKETPLACE]: 'marketplace',
  [RESOURCES.ER_DIAGRAM]:  'er-diagram',
});

/**
 * Build the `?target=` value the bootstrap page uses to know where to
 * redirect once the JWT arrives over postMessage. This value is
 * safe-by-construction: it never contains a secret.
 */
export function buildBootstrapTarget(resource, id) {
  const standalone = STANDALONE_TARGETS[resource];
  if (standalone) return standalone;
  if (!id) {
    throw new Error(`@inzara/embed-react: 'id' is required for resource '${resource}'`);
  }
  return `view/${resource}/${id}`;
}
